"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAssetMediators = exports.getAuthorization = exports.prepareRemoveAssetMediators = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
function prepareRemoveAssetMediators(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx }, }, context, } = this;
        const { asset, mediators: mediatorInput } = args;
        const currentMediators = yield asset.getRequiredMediators();
        const removeMediators = mediatorInput.map(mediator => (0, internal_2.asIdentity)(mediator, context));
        removeMediators.forEach(({ did: removeDid }) => {
            const alreadySetDid = currentMediators.find(({ did: currentDid }) => currentDid === removeDid);
            if (!alreadySetDid) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.ValidationError,
                    message: 'One of the specified mediators to remove is not set',
                    data: { assetId: asset.id, removeDid },
                });
            }
        });
        const rawNewMediators = (0, conversion_1.identitiesToBtreeSet)(removeMediators, context);
        const rawAssetId = (0, conversion_1.assetToMeshAssetId)(asset, context);
        return {
            transaction: tx.asset.removeMandatoryMediators,
            args: [rawAssetId, rawNewMediators],
            resolver: undefined,
        };
    });
}
exports.prepareRemoveAssetMediators = prepareRemoveAssetMediators;
/**
 * @hidden
 */
function getAuthorization(args) {
    return {
        permissions: {
            transactions: [types_1.TxTags.asset.RemoveMandatoryMediators],
            portfolios: [],
            assets: [args.asset],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
const removeAssetMediators = () => new internal_1.Procedure(prepareRemoveAssetMediators, getAuthorization);
exports.removeAssetMediators = removeAssetMediators;
//# sourceMappingURL=removeAssetMediators.js.map